<div class="markdown-container forceDefaultColors">
  <div
    *ngIf="!markdownUrl"
    class="editor-section"
    [ngClass]="{ laptopView: currentView === ViewType.Laptop, mobileView: currentView === ViewType.Mobile, blockEditor: formStep === FormSteps.extraConfigurations }"
  >
    <div #editorContainer class="editor"></div>
    <div class="toastui-editor footer">
      <div class="footer__item">
        <div></div>
        <div>{{ 'documents.preview' | translate }}</div>
        <div class="d-flex align-items-center">
          <button type="button" class="btn-S btn-text icon-only" (click)="toggleViewMode(ViewType.Mobile)" [ngClass]="{ active: currentView === ViewType.Mobile }">
            <i class="fa-regular fa-mobile-notch"></i>
          </button>
          <button type="button" class="btn-S btn-text icon-only ml-1" (click)="toggleViewMode(ViewType.Laptop)" [ngClass]="{ active: currentView === ViewType.Laptop }">
            <i class="fa-regular fa-laptop"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="markdownUrl" class="viewer-section">
    <div #editorViewer class="viewer"></div>
  </div>
</div>
